
<template>
  <div class="wrapper">
    <div
      v-if="communityJoinRequests && communityJoinRequests.length > 0"
      class="join-request-tile"
    >
      <div class="title-container">
        <span class="title">{{ $t('community.joinRequestTile.pendingApprovalRequests') }}</span>
      </div>
      <div class="valid-join-container">
        <div
          v-for="joinRequest in communityJoinRequests"
          :key="joinRequest.id"
        >
          <valid-join-request :join-request="joinRequest" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidJoinRequest from '@/components/community/ValidJoinRequest'
import { mapState } from 'vuex'

export default {
  name: 'JoinRequestTile',
  components: { ValidJoinRequest },
  props: {
    communityDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      communityJoinRequests: state => state.joinRequest.communityJoinRequests
    })
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
}
  .join-request-tile {
    margin-top: 1rem;
    width: 100%;
    height: fit-content;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
    .title-container {
        padding: 10px 0;
        .title {
            font-size: 15px;
            font-weight: 600;
        }
    }
    .valid-join-container {
        padding: 15px 0 10px 0;
    }
  }
</style>
